import React from 'react';
import { variables } from 'theme/variables';
const {
  custom_button_blue,
  color_white,
  custom_pale_blue
} = variables;

const SVGLogo = (props) => {
  return (
    <svg width="6499px" height="1140px" viewBox="0 0 6499 1140" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Group">
              <circle id="Oval" stroke="#0668EF" strokeWidth="20" cx="570" cy="570" r="560"></circle>
              <path d="M345.382087,358.134852 C255.055331,515.118661 258.775743,712.968557 383.165951,827.084606 C389.099411,832.527985 410.704692,844.210707 337.390625,617.609862 C320.965922,566.844003 348.996239,351.85362 345.382087,358.134852 Z" id="Oval" fill="#FFFFFF"></path>
              <circle id="Oval" stroke="#0668EF" strokeWidth="20" cx="570" cy="570" r="380"></circle>
              <rect id="Rectangle" fill="#FFFFFF" x="570" y="245" width="1208" height="652"></rect>
              <circle id="Oval" fill="#0668EF" cx="765.5" cy="245.5" r="21.5"></circle>
              <circle id="Oval" fill="#0668EF" cx="1028.5" cy="251.5" r="21.5"></circle>
              <text id="Magnetic-Resonance-T" fill="#0D3872" fontFamily="Roboto-Bold, Roboto" fontSize="409" fontWeight="bold" letterSpacing="-7.01885593">
                  <tspan x="391" y="694">Magnetic Resonance </tspan>
                  <tspan x="4216.0348" y="694" fontFamily="Roboto-Light, Roboto" fontWeight="300">Technologies</tspan>
              </text>
              <path d="M768.252489,880 C757.629117,896.899625 749.544955,910.872577 744,921.918855" id="Path" stroke="#0668EF" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" transform="translate(756.126244, 900.959428) rotate(-148.000000) translate(-756.126244, -900.959428) "></path>
              <path d="M1026.40093,889.322266 C1016.53608,905.321083 1008.45192,919.294035 1002.14844,931.241121" id="Path" stroke="#0668EF" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" transform="translate(1014.274682, 910.281693) rotate(-173.000000) translate(-1014.274682, -910.281693) "></path>
              <path d="M147.890625,358 C84.3802083,499.184331 81.65625,631.954372 139.71875,756.310123" id="Path-2" strokeOpacity="0.0850906906" stroke="#0668EF" strokeWidth="20" strokeLinecap="round"></path>
          </g>
      </g>
  </svg>
 )
}


export default SVGLogo;
